import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetSizeUomsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.SizeUomDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.SizeUomDocumentSortInput> | Types.SizeUomDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetSizeUomsQuery = { __typename?: 'Query', sizeUoms?: { __typename?: 'SizeUomsConnection', totalCount: number, nodes?: Array<{ __typename?: 'SizeUomDocument', code: string, description: string, eachesPerUnit: number, status: Types.SizeUomStatus }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type SizeUomSummaryFragment = { __typename?: 'SizeUomDocument', code: string, description: string, eachesPerUnit: number, status: Types.SizeUomStatus };

export const SizeUomSummaryFragmentDoc = new TypedDocumentString(`
    fragment SizeUomSummary on SizeUomDocument {
  code
  description
  eachesPerUnit
  status
}
    `, {"fragmentName":"SizeUomSummary"});
export const GetSizeUomsDocument = new TypedDocumentString(`
    query GetSizeUoms($where: SizeUomDocumentFilterInput, $order: [SizeUomDocumentSortInput!], $first: Int, $after: String) {
  sizeUoms(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      ...SizeUomSummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment SizeUomSummary on SizeUomDocument {
  code
  description
  eachesPerUnit
  status
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetSizeUoms: build.query<GetSizeUomsQuery, GetSizeUomsQueryVariables | void>({
      query: (variables) => ({ document: GetSizeUomsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetSizeUomsQuery, useLazyGetSizeUomsQuery } = injectedRtkApi;
